import { render, staticRenderFns } from "./IconCareer.vue?vue&type=template&id=0a22b042&scoped=true"
import script from "./IconCareer.vue?vue&type=script&lang=js"
export * from "./IconCareer.vue?vue&type=script&lang=js"
import style0 from "./IconCareer.vue?vue&type=style&index=0&id=0a22b042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22b042",
  null
  
)

export default component.exports